// extracted by mini-css-extract-plugin
export var highlightFade = "_31-4";
export var highlighted = "_31-3";
export var table = "_31-1";
export var tableContainer = "_31-0";
export var totalsRow = "_31-2";